module.exports = __webpack_public_path__ + "img/spacevsground.5e5a2a96.jpg";